<template>
    <!-- left sidebar -->
    <div id="citation-sidebar" class="sidebar">
        <h4 class="quick-guides-title">
            {{ $t('Quick Guides') }}
        </h4>
        <ul class="quick-guides">
            <li class="quick-guides__item">
                <a class="link" v-bind:href="`/citation-guide/apa`">{{ $t('APA Citation Guide') }}</a>
            </li>
            <li class="quick-guides__item">
                <a class="link" v-bind:href="`/citation-guide/mla`">{{ $t('MLA Citation Guide') }}</a>
            </li>
            <li class="quick-guides__item">
                <a class="link" v-bind:href="`/citation-guide/chicago`">{{ $t('Chicago Citation Guide') }}</a>
            </li>
            <li class="quick-guides__item">
                <a class="link" v-bind:href="`/citation-guide/vancouver`">{{ $t('Vancouver Citation Guide') }}</a>
            </li>
        </ul>

        <h4 class="citations-title">
            {{ $t('Citation Generator') }}
        </h4>
        <ul>
            <li class="citations__item">
                <a class="link" v-bind:href="`/apa-citation-generator`">{{ $t('apa.page-title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`/mla-citation-generator`">{{ $t('mla.page-title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`/chicago-citation-generator`">{{ $t('chicago.page-title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`/vancouver-citation-generator`">{{ $t('vancouver.page-title') }}</a>
            </li>
        </ul>

        <h4 class="citations-title">
            {{ $t('Citation Sources') }}
        </h4>
        <ul>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link1.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link1.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link2.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link2.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link3.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link3.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link4.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link4.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link5.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link5.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link6.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link6.title') }}</a>
            </li>
            <li class="citations__item">
                <a class="link" v-bind:href="`${$t('citation_sources.link7.uri')}${utm}`"
                   target="_blank">{{ $t('citation_sources.link7.title') }}</a>
            </li>
        </ul>
    </div>
    <!-- /left sidebar -->
</template>

<script>
export default {
    name: "SidebarLeft",
    data() {
        return {
            utm: "?utm_source=wordvice&utm_medium=citation_generator&utm_campaign=sidebar_click",
        }
    },
}
</script>

<style scoped>
.citations-title {
    margin-top: 3rem !important;
}

#citation-sidebar {
    width: 100% !important;
    margin-bottom: 2.5em;
}

#citation-sidebar h4 {
    font-weight: 700;
    margin-bottom: 1em;
}

#citation-sidebar .link {
    display: block;
    padding: .375em 0;
    font-size: .875em;
    color: #333;
}

#citation-sidebar ul {
    padding: 0;
}

#citation-sidebar li {
    list-style: none;
}

@media (min-width: 992px) {
    #citation-sidebar .link:hover {
        text-decoration: underline;
    }
}

@media (max-width: 991px) {
    #citation-sidebar {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/generator/SidebarLeft.vue